import * as React from 'react';
import { EntityConfig, entityStandardFormFields } from '@shapeable/core';
import { Reason as MyType } from '@shapeable/kelp-forest-alliance-types';
const gql = String.raw;

export const Reason: EntityConfig<MyType> = {
  name: 'Reason',
  label: 'Reason for Decline',
  pluralLabel: 'Reasons for Decline',
  type: 'taxonomy',
  icon: ({ icons }) => icons.Entities.Target,
  autoRoutes: ['list', 'create', 'update'],
  form: {
    fields: {
      ...entityStandardFormFields,
      description: { type: 'longText' },
    }
  }
};